import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { type ApplyAttempt, fetchJson } from '@/lib/api';

interface SubmitResult {
  attempt: ApplyAttempt;
  reason?: string;
  submitted: boolean;
}

export const useSubmitApplication = () => {
  const queryClient = useQueryClient();
  const { push } = useToast();

  return useMutation({
    mutationFn: (vars: { applicationId: number }) =>
      fetchJson<SubmitResult>(
        `/api/applications/${vars.applicationId}/submit`,
        { method: 'POST' },
      ),
    onError: (error: Error) => push(error.message || 'Submit failed', 'error'),
    onSuccess: (result, vars) => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['stats'] });
      queryClient.invalidateQueries({
        queryKey: ['applyAttempt', vars.applicationId],
      });

      if (!result.submitted) {
        push(`Not submitted: ${result.reason ?? 'unknown reason'}`, 'info');
      }
    },
  });
};
